module.exports = __webpack_public_path__ + "static/media/bus_stop_icon.844fa978.svg";